import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonos = [{
  num: '01',
  title: 'CHECKLIST MAESTRO DE SEGURIDAD',
  desc: 'Detectá riesgos visibles en tu casa ambiente por ambiente antes de tocar nada. Hoja printable para inspección mensual.',
  value: '$15.000'
}, {
  num: '02',
  title: 'MAPA RÁPIDO DE TU TABLERO',
  desc: 'Entendé qué controla cada térmica. Plantilla para pegar dentro del tablero. Nunca más el pánico de las 2 AM.',
  value: '$12.000'
}, {
  num: '03',
  title: 'GUÍA DE HERRAMIENTAS SEGURAS',
  desc: 'Comprá solo lo que necesitás. La diferencia entre herramienta común y VDE certificada. Kit mínimo desde $35.000.',
  value: '$10.000'
}, {
  num: '04',
  title: 'PLANTILLAS DE REGISTRO DE FALLAS',
  desc: 'Documentá cada falla como un técnico. Detectá patrones. Hoja lista para mostrarle al electricista si lo necesitás.',
  value: '$12.000'
}, {
  num: '05',
  title: 'MANUAL DE ERRORES MÁS COMUNES',
  desc: 'Los 20 errores eléctricos domésticos más peligrosos. Tabla de consecuencias. Corrección rápida por orden de urgencia.',
  value: '$10.000'
}, {
  num: '06',
  title: 'PLAN DE ACCIÓN EN EMERGENCIA',
  desc: '8 protocolos para actuar sin pánico. Árbol de decisión simple. Hoja plastificable para pegar cerca del tablero.',
  value: '$10.000'
}];
export function BonosSection() {
  return <section className="py-14 relative" data-id="element-27">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-28"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-29">
        <div className="text-center mb-10" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-3 flex items-center justify-center gap-4" data-id="element-31">
            <Gift className="w-10 h-10 text-gold" data-id="element-32" />
            <span data-id="element-33">6 BONOS INCLUIDOS</span>
            <Gift className="w-10 h-10 text-gold" data-id="element-34" />
          </h2>
          <p className="text-xl text-gold font-medium uppercase tracking-widest" data-id="element-35">
            Siempre Gratis
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-36">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-b from-petroleum to-graphite border border-gold/20 rounded-2xl p-6 hover:border-gold/50 transition-colors relative overflow-hidden" data-id="element-37">
              <div className="absolute top-0 right-0 bg-gold text-graphite font-bold px-3 py-1 rounded-bl-lg text-sm" data-id="element-38">
                Bono {bono.num}
              </div>

              <h3 className="text-lg font-bold mb-3 pr-16 text-white mt-4" data-id="element-39">
                {bono.title}
              </h3>
              <p className="text-textsecondary text-sm mb-6 min-h-[60px]" data-id="element-40">
                {bono.desc}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-41">
                <span className="text-textsecondary line-through text-sm" data-id="element-42">
                  Valor: {bono.value}
                </span>
                <span className="text-gold font-bold" data-id="element-43">GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gold/10 border border-gold/30 rounded-xl p-6 text-center" data-id="element-44">
          <p className="text-xl md:text-2xl font-bold" data-id="element-45">
            Valor total bonos:{' '}
            <span className="line-through text-textsecondary mx-2" data-id="element-46">
              $69.000
            </span>
            <span className="text-gold" data-id="element-47">→ GRATIS con tu Bundle</span>
          </p>
        </motion.div>
      </div>
    </section>;
}